module.exports = __webpack_public_path__ + "static/media/TowTruck.5aeedccd.svg";